(function() {
    angular.module('GorillaBoy.services')
        .factory('BaseHttpService', ['$http',
            '$q',
            '$log',
            '$timeout',
            'EndpointService',
            'AppConstants',
            factoryFn
        ]);

    function factoryFn($http, $q, $log, $timeout, EndpointService, AppConstants) {

        var service = {};

        function isRetryableErrorCode(statusCode) {
            return (statusCode > 500 && statusCode < 600);
        }

        service.callWithExpRetries = function(httpConfig) {
            var retryCount = 0,
                exp = 1,
                deferred = $q.defer();

            makeTheCall();
            return deferred.promise;

            function successCallBack(response) {
                deferred.resolve(response);
            }

            function errorCallBack(response) {
                if (!isRetryableErrorCode(response.status)) {
                    deferred.reject(response);
                    return;
                }

                if (retryCount < AppConstants.HTTP_THROTTLE_MAX_RETRY_COUNT) {
                    retryCount++;
                    $timeout(makeTheCall, Math.min(Math.pow(2, exp), AppConstants.HTTP_THROTTLE_MAX_RETRY_TIME_IN_SEC) * 1000);
                } else {
                    deferred.reject(response);
                }
            }

            function makeTheCall() {
                $http(EndpointService.tokenize(httpConfig)).then(successCallBack, errorCallBack);
            }
        };
        
        return service;
    }
}());